var path = '/templates/projects.settings/initialization/page_type.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.pageType.peejitaipu' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.pageType.peejitaipukabaa_ritsu' | translate }}\" indicator=page_types_cover_rate></zc-session-sampler><zc-page-type-editor project-id=project.id></zc-page-type-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.settings/initialization/page_type.html
// module id = 1499
// module chunks = 0